import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormPlycaModule } from '../../components/forms/formPlyca.module';
import { ContractsModule } from '../../dossiers/contracts/contracts.module';
import { SettlementComponent } from './component/settlement.component';

@NgModule({
  declarations: [SettlementComponent],
  imports: [
    CommonModule,
    FormPlycaModule,
    ContractsModule
  ],
  exports: [SettlementComponent]
})
export class SettlementModule {

}